angular.module('impactx.purchaseorder').controller('PurchaseOrderSupplierDetailCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    '$timeout',
    '$mdDialog',
    '$mdToast',
    'selectedListItems',
    'PurchaseOrderService',
    'ToolbarService',
    'SubsequentPurchaseOrderDataService',
    'ixaPrintService',
    PurchaseOrderSupplierDetailCtrl
]);

function PurchaseOrderSupplierDetailCtrl($scope, dataGen, $routeParams, $timeout, $mdDialog, $mdToast, selectedListItems,
                                         PurchaseOrderService, ToolbarService, SubsequentPurchaseOrderDataService,
                                         ixaPrintService) {
    $scope.isSupplier = {value: true};
    var self = this;
    var pohId = 0;
    if ($routeParams.id) {
        pohId = $routeParams.id;
    }
    else {
        pohId = selectedListItems.getFirstSelectedId();
    }

    var printId = $routeParams.printId;

    $scope.selectedPurchaseItems = [];

    $scope.selectedPurchaseOrderItems = [];

    $scope.getPageData = function () {
        dataGen.getData($scope, {id: pohId}, "/purchaseorder/supplier/view").then(function () {
            defineButtons();

            if (printId) {
                ixaPrintService.print($scope.printTokens[printId]);
            }
        });
    };

    $scope.getPageData();

    $scope.showItemComments = {value: false};

    this.toggleItemComment = function () {
        $scope.showItemComments.value = !$scope.showItemComments.value;
    };

    $scope.showHeaderComment = {value: false};

    this.toggleComment = function () {
        $scope.showHeaderComment.value = !$scope.showHeaderComment.value;
    };

    /**
     * Copies status about possibility of close or re-open invoice processing
     * from backend data to current scope data POH.
     *
     * @param backendData backend data
     * @param scopeToModify scope to modify
     */
    function copyStatusValuesForCloseAndReopenInvoice(backendData, scopeToModify) {
        if (backendData && backendData.data && impactX.isDefined(scopeToModify, 'data.poh')) {

            scopeToModify.data.poh.canReopenInvoice = backendData.data.canReopenInvoice;
            scopeToModify.data.poh.canCloseInvoice = backendData.data.canCloseInvoice;
        }
    }

    /**
     * Used only by supplier to close the invoice process.
     */
    this.closeInvoice = function () {
        var promise,
            responseData = {};

        if (pohId > 0) {
            // console.log("Details: Close invoice");
            promise = PurchaseOrderService.closeInvoice([pohId], false, responseData);
            if (promise) {
                promise.then(function () {
                    copyStatusValuesForCloseAndReopenInvoice(responseData, $scope);
                });
            }
        }
    };

    /**
     * Used only by supplier to reopen the invoice process.
     */
    this.reopenInvoice = function () {
        var promise,
            responseData = {};

        if (pohId > 0) {
            // console.log("Details: Reopen invoice");
            promise = PurchaseOrderService.reopenInvoice([pohId], false, responseData);

            if (promise) {
                promise.then(function () {
                    copyStatusValuesForCloseAndReopenInvoice(responseData, $scope);
                });
            }
        }
    };

    self.openSubsequentPurchaseOrderDataDialog = function (event, poh) {
        SubsequentPurchaseOrderDataService.openViewDialog(event, 0, 0, poh.id);
    };

    self.formatAddressValue = function (value) {
        if(value) {
            return value.replace(/,\s/g, '<br/>')
        }
        return '';
    }

    self.canJumpToCancelRequest = function () {
        return $scope.data.poh.crhId > 0;
    };

    self.getCancelRequestLink = function () {
        return "crhdetailssupplier/" + $scope.data.poh.crhId;
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.comment,
                action: self.toggleComment,
                type: 'dialogaction',
                condition: canToggleHeaderComment
            },
            {
                label: $scope.trns.cancelRequest,
                linkFunction: self.getCancelRequestLink,
                type: 'link',
                condition: self.canJumpToCancelRequest,
                process: 'CancellationRequestSupplier'
            },
            {
                label: $scope.trns.comment,
                action: self.toggleItemComment,
                type: 'dialogaction',
                condition: canToggleItemComment
            },
            {
                label: $scope.trns.createDelNote,
                action: self.newDeliveryNote,
                type: 'dialogaction',
                condition: canCreateDeliveryNote
            },
            {
                label: $scope.trns.createDelNote,
                action: self.newDeliveryNoteItems,
                type: 'dialogaction',
                condition: canCreateDeliveryNoteItems
            },
            {
                label: $scope.trns.newComplaint,
                action: self.newComplaint,
                type: 'dialogaction',
                condition: canCreateComplaint
            },
            {
                label: $scope.trns.reExport,
                action: self.reExport,
                type: 'dialogaction',
                condition: canReExport
            },
            {
                label: $scope.trns.deliveryOverdue,
                action: self.showDeliveryOverdueDialog,
                type: 'dialogaction',
                condition: canDeliveryOverdue
            },
            {
                label: $scope.trns.deliveryOverdueMails,
                action: self.showSentDeliveryOverdue,
                type: 'dialogaction',
                condition: canSendDeliveryOverdue
            },
            {
                label: $scope.trns.cancel,
                action: self.cancelItems,
                type: 'dialogaction',
                condition: canCancelItem
            },
            {
                label: $scope.trns.cancelAll,
                action: self.cancelAll,
                type: 'dialogaction',
                condition: canCancel
            },
            {
                label: $scope.trns.closeInvoice,
                action: self.closeInvoice,
                type: 'dialogaction',
                condition: canCloseInvoice,
                process: 'CloseInvoice'
            },
            {
                label: $scope.trns.reOpenInvoice,
                action: self.reopenInvoice,
                type: 'dialogaction',
                condition: canReopenInvoice,
                process: 'ReopenInvoice'
            },
            {
                label: $scope.trns.createOGD,
                action: self.reportOpenGovernmentData,
                type: 'dialogaction',
                condition: canReportOGD
            },
            {
                label: $scope.trns.createTemplate,
                action: self.createBasketTemplate,
                type: 'dialogaction',
                condition: canCreateTemplate
            },
            {
                label: $scope.trns.print,
                type: 'print',
                condition: self.canPrintSelected,
                params: {
                    printToken: $scope.printTokens.order,
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function canToggleHeaderComment() {
        return !isSupplier() && hasNoItemsSelected();
    }

    function canToggleItemComment() {
        return !isSupplier() && !hasNoItemsSelected();
    }

    function canCreateDeliveryNote() {
        return $scope.data.poh.isDNHAllowed && hasNoItemsSelected();
    }

    function canCreateDeliveryNoteItems() {
        return $scope.data.poh.isPartialDNHAllowed && !hasNoItemsSelected();
    }

    function canCreateComplaint() {
        return $scope.data.canComplain;
    }

    function canReExport() {
        return !isSupplier() && hasNoItemsSelected() && !$scope.data.poh.readOnly && $scope.data.poh.canReExport;
    }

    function canDeliveryOverdue() {
        return !isSupplier() && hasNoItemsSelected() > 0 && !$scope.data.poh.readOnly && $scope.data.poh.canReExport;
    }

    function canSendDeliveryOverdue() {
        return !isSupplier() && hasNoItemsSelected() && $scope.data.poh.sentDeliveryOverdueMails.length > 0;
    }

    function canCancelItem() {
        return canCancel() && !hasNoItemsSelected();
    }

    function canCancel() {
        return $scope.data.poh.canCancel;
    }

    function canCloseInvoice() {
        return $scope.data.poh.canCloseInvoice;
    }

    function canReopenInvoice() {
        return $scope.data.poh.canReopenInvoice;
    }

    function canReportOGD() {
        return $scope.data.poh.canReportOGD;
    }

    function canCreateTemplate() {
        return $scope.data.poh.canCreateTemplate;
    }

    function isSupplier() {
        return $scope.isSupplier.value;
    }

    function hasNoItemsSelected() {
        return !$scope.selectedPurchaseOrderItems.length;
    }
}